var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg9D38F3641E43Ba855Da244Fe64413Ee2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "420px",
    height: "420px",
    viewBox: "0 0 420 420",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pohjoinen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pohjoinen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210,419 C94.5722857,419 1,325.427714 1,210 C1,94.5722857 94.5722857,1 210,1 C325.427714,1 419,94.5722857 419,210 C419,325.427714 325.427714,419 210,419 Z",
    id: "Fill-17",
    fill: "#D4791E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(71.000000, 60.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.725464,188 L181.725464,220 L92,220 L92,188 L181.725464,188 Z M138.001003,5.68434189e-14 L190.616977,76.8656478 L178.495174,131.989064 L215.534905,95.2194378 L276,162.793629 L259.479036,177.420353 L214.583077,127.245817 L174.535,167 L148.155,167 L166.97584,81.417996 L138.001003,39.0892234 L109.026167,81.417996 L127.846,167 L101.466,167 L61.4002503,127.227274 L16.4877948,177.193129 L0,162.52942 L60.485781,95.2379808 L97.5068325,131.989064 L85.3850295,76.8656478 L138.001003,5.68434189e-14 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9D38F3641E43Ba855Da244Fe64413Ee2);
export default __webpack_public_path__ + "static/media/9d38f3641e43ba855da244fe64413ee2.79620a601e4c6375ac50e6a1efed95bf.svg";
export { ForwardRef as ReactComponent };